export var config = {
  background: '#000c18',
  foreground: '#6688cc',
  selection: '#770811',
  selectionMatch: '#770811',
  cursor: '#ddbb88',
  dropdownBackground: '#181f2f',
  activeLine: '#0055ff30',
  matchingBracket: '#082050',
  keyword: '#225588',
  storage: '#225588',
  variable: '#2277ff',
  parameter: '#2277ff',
  function: '#9966b8',
  string: '#22aa44',
  constant: '#f280d0',
  type: '#9966b8',
  class: '#ddbb88',
  number: '#f280d0',
  comment: '#384887',
  heading: '#6688cc',
  invalid: '#A22D44',
  regexp: '#22aa44',
  tag: '#225588'
};